var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureStreamlineIconCloudSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.148,
    height: 64.013,
    viewBox: "0 0 64.148 64.013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-cloud-settings_64x64",
    "data-name": "streamline-icon-cloud-settings@64x64",
    transform: "translate(0.033 0.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M42,44a4,4,0,1,0,4-4A4,4,0,0,0,42,44Z",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M49.4,28.533l1.181,3.872a2.645,2.645,0,0,0,3.128,1.816l3.928-.909a3.571,3.571,0,0,1,3.4,5.915l-2.747,2.963a2.667,2.667,0,0,0,0,3.632l2.747,2.963a3.571,3.571,0,0,1-3.4,5.917l-3.928-.912a2.651,2.651,0,0,0-3.128,1.816L49.4,59.467a3.547,3.547,0,0,1-6.795,0l-1.179-3.875a2.667,2.667,0,0,0-3.131-1.816l-3.925.912a3.571,3.571,0,0,1-3.4-5.917l2.747-2.963a2.667,2.667,0,0,0,0-3.632l-2.747-2.963a3.568,3.568,0,0,1,3.4-5.915l3.925.909a2.648,2.648,0,0,0,3.131-1.816L42.6,28.52a3.547,3.547,0,0,1,6.795.013Z",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M61.36,24.963A12.981,12.981,0,0,0,41.627,18.3,20,20,0,1,0,22,42",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureStreamlineIconCloudSettings);
export default __webpack_public_path__ + "static/media/feature-streamline-icon-cloud-settings.97e86a2a.svg";
export { ForwardRef as ReactComponent };